export const FINAL_SWITCH_ACTIVE_TAB = 'FINAL_SWITCH_ACTIVE_TAB';

export function switchActiveTab (activeTab) {
    return {
        type: FINAL_SWITCH_ACTIVE_TAB,
        activeTab: activeTab
    };
};
